import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const GlanceCard = ({ number, title, description }) => {
  return (
    <Card 
      sx={{ 
        height: '100%',
        bgcolor: 'primary.dark',
        color: 'primary.contrastText',
      }}
    >
      <CardContent>
        <Typography variant="h4" color="secondary">
          {number}
        </Typography>
        <Typography variant="subtitle2" color="secondary" sx={{ mb: 2 }} gutterBottom noWrap={false}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }} noWrap={false}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default GlanceCard; 